import { createAction } from 'redux-actions';

export const GET_TOKEN = 'GET_TOKEN';
export const getToken = createAction(GET_TOKEN);

export const GET_TOKEN_SUCCESS = 'GET_TOKEN_SUCCESS';
export const getTokenSuccess = createAction(GET_TOKEN_SUCCESS);
